import OfferPage from 'components/pages/Offer';

import { getTopbarAd } from 'lib/ads';
import { withSSRInternalProps } from 'lib/hofs';
import { toCategoryLink, toSubcategoryLink } from 'lib/links';
import { get, redirectTo404IfParamsAreInvalid } from 'lib/request';

import APP from 'constants/app';
import LINKS from 'constants/links';
import OFFER from 'constants/offer';
import STATUS_CODES from 'constants/statusCodes';

const Offer = ({ ...props }) => <OfferPage {...props} />;

export const getServerSideProps = withSSRInternalProps(
  async ({ params: { offerSlug } }) => {
    const isSlugValidOrRedirectTo404Page =
      redirectTo404IfParamsAreInvalid(offerSlug);

    if (!isSlugValidOrRedirectTo404Page) {
      return isSlugValidOrRedirectTo404Page;
    }

    const [offerKey] = offerSlug;

    try {
      const [
        offer,
        categories,
        stores,
        { landings: featuredLandings },
        { landings: highlightedLandings },
        topbarAd,
      ] = await Promise.all([
        get(`/offer/${offerSlug}`),
        get('/category?categories_selection=true'),
        get('/store?from=topbar'),
        get('/landings?is-featured=true'),
        get('/landings?is-highlighted=true'),
        getTopbarAd(),
      ]).catch(({ message }) => {
        throw new Error(message);
      });
      let featuredLanding = null;

      if (featuredLandings.length > 0) {
        [featuredLanding] = featuredLandings;
      }

      if (offer.offerStatusName === OFFER.STATUSES.ARCHIVED) {
        const { categorySlug, subcategorySlug } = offer;

        return {
          redirect: {
            destination: subcategorySlug
              ? toSubcategoryLink(subcategorySlug)
              : toCategoryLink(categorySlug),
            permanent: false,
          },
        };
      }

      return {
        props: {
          offer,
          offerKey,
          [APP.CTX_OPTIONAL_PROPS]: {
            categories,
            featuredLanding,
            highlightedLandings,
            stores,
            topbarAd,
          },
        },
      };
    } catch ({ message }) {
      // Offer can be accessed but needs authentication..
      // Fetching will be done on client
      if (message === STATUS_CODES[401]) {
        return { props: { offerKey } };
      }

      // Offer can't be accessed, should redirect to origin
      if (message === STATUS_CODES[403]) {
        return { redirect: { destination: LINKS.HOME, permanent: true } };
      }

      // Offer doesn't exist
      return { redirect: { destination: LINKS[404], permanent: false } };
    }
  }
);

export default Offer;
